module.exports = __webpack_public_path__ + "img/datamatrix_300ppi.307f0821.png";